export const getCourseCardState = (enrollment, ownershipStatus, progress) => {
  if (ownershipStatus !== 'ready') {
    return {
      isEnrolled: false,
      isCompleted: false,
      progress: null,
      progressLoading: false,
      showPrice: false,
      primaryLabel: ownershipStatus === 'error' ? 'Course unavailable' : 'Checking access',
      disablePrimaryAction: true,
    };
  }

  const isEnrolled = Boolean(enrollment);
  const isCompleted = isEnrolled && (
    Number(enrollment.is_completed) === 1 || progress?.completed === true
  );

  return {
    isEnrolled,
    isCompleted,
    progress: progress?.status === 'ready' ? progress.percentage : null,
    progressLoading: isEnrolled && progress == null,
    showPrice: !isEnrolled,
    disablePrimaryAction: false,
  };
};
